import React from 'react';
import { Hero } from './Hero';
import { StickyCTABar } from './StickyCTABar';
import { PurchaseNotification } from './PurchaseNotification';
import { MetricsBar } from './MetricsBar';
import { ScenesSection } from './ScenesSection';
import { WhatsInsideSection } from './WhatsInsideSection';
import { ProductPreview } from './ProductPreview';
import { DeliverySection } from './DeliverySection';
import { BonusSection } from './BonusSection';
import { OfferSection } from './OfferSection';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { WhyExistsSection } from './WhyExistsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { FooterSection } from './FooterSection';
export function LandingPage() {
  return <div className="w-full bg-cream text-ink selection:bg-gold/25" data-id="element-90" data-mp="6viqp2gpaluo">
      <main data-id="element-91" data-mp="1x7gurqeobcg">
        <Hero data-id="element-92" data-mp="1xh9kn2u4wlu" />
        <MetricsBar data-id="element-93" data-mp="1z244cp5gfjp" />
        <ScenesSection data-id="element-94" data-mp="1yiurkdkezha" />
        <WhatsInsideSection data-id="element-95" data-mp="2ni75fizegf01" />
        <ProductPreview data-id="element-96" data-mp="2nhyqlljpuzm7" />
        <DeliverySection data-id="element-97" data-mp="2nhfb0bhjgnbc" />
        <BonusSection data-id="element-98" data-mp="2ng4628ccx9in" />
        <OfferSection data-id="element-99" data-mp="2s8niv33800me" />
        <GuaranteeSection data-id="element-100" data-mp="2s96z8fd82gyb" />
        <TestimonialsSection data-id="element-101" data-mp="2sai3shehrsqh" />
        <WhyExistsSection data-id="element-102" data-mp="2sart02rppvv4" />
        <FAQSection data-id="element-103" data-mp="2ei27dzg3isyj" />
        <FinalCTA data-id="element-104" data-mp="2eittmjnszec5" />
      </main>
      <FooterSection data-id="element-105" data-mp="2effr9bf5354p" />
      <div className="h-[66px] bg-carbon" aria-hidden="true" data-id="element-106" data-mp="2ij40dyjf68s2" />
      <StickyCTABar data-id="element-107" data-mp="2ijdqdm4gsfxr" />
      <PurchaseNotification data-id="element-108" data-mp="2igrhnj5u7udy" />
    </div>;
}